export default __webpack_public_path__ + "static/media/Asus Transformer.8399f169.png";